import { Card, Container, Grid } from "@eworkit/iris";
import React from "react";
import { FC } from "react";

import { DashboardInfoStack, DashboardInfoStackProps } from "../components";

type DashboardStatsSectionProps = {
  items: DashboardInfoStackProps[];
};

export const DashboardStatsSection: FC<DashboardStatsSectionProps> = ({ items }) => {
  return (
    <Container sx={{ gridColumn: ["1 / 5", null, null, "1 / 4"] }}>
      <Card>
        <Container sx={{ py: ["0", null, null, "sm"] }}>
          <Grid columns="repeat(3, 1fr)">
            {items.map(item => (
              <DashboardInfoStack key={item.label} number={item.number} label={item.label} route={item.route} />
            ))}
          </Grid>
        </Container>
      </Card>
    </Container>
  );
};
